import { render, staticRenderFns } from "./Charges.vue?vue&type=template&id=7cff80ac&scoped=true"
import script from "./Charges.vue?vue&type=script&setup=true&lang=js"
export * from "./Charges.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Charges.vue?vue&type=style&index=0&id=7cff80ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cff80ac",
  null
  
)

export default component.exports